/** @jsxImportSource @emotion/react */
import * as s from './style'
import React, { useState } from 'react';

const ModeSelectMenuButton = ({ mode, setMode }) => {
    const [ isOpen, setIsOpen ] = useState(true);

    const onClickMenuOpenButtonHandle = () => {
        setIsOpen(!isOpen);
    }

    const onClickSelectorHandle = (modename) => {
        setMode(modename);
    }

    return (
        <div class="model-select-menu">
            <div css={s.menuOpenButton} onClick={onClickMenuOpenButtonHandle}>
                <link href="https://viglino.github.io/font-gis/css/font-gis.css" rel="stylesheet" />
                <img css={s.menuOpenButtonImg(isOpen)} src={"/images/divided_button.png"} alt={"통계 비교 방식 버튼 이미지"}/>
            </div>
            <div css={s.modeSelectorContainer(isOpen)}>
                <button css={s.modeSelector(mode === 'singleMap')} onClick={() => onClickSelectorHandle("singleMap")}>
                    <div css={s.modeSelectIconContainer}>
                        <i class="fg-start"/>
                    </div>
                    <span class="mode-selector-text" css={s.modeSelectText}>Single Map</span>
                </button>
                <button css={s.modeSelector(mode === 'doubleMap')} onClick={() => onClickSelectorHandle("doubleMap")}>
                    <div css={s.modeSelectIconContainer}>
                        <i class="fg-screen-dub"/>
                    </div>
                    <span class="mode-selector-text" css={s.modeSelectText}>Double Map</span>
                </button>
                <button css={s.modeSelector(mode === 'swipeMap')} onClick={() => onClickSelectorHandle("swipeMap")}>
                    <div css={s.modeSelectIconContainer}>
                        <i class="fg-screen-split-h"/>
                    </div>
                    <span class="mode-selector-text" css={s.modeSelectText}>Swipe Map</span>
                </button>
                <button css={s.modeSelector(mode === 'spyMap')} onClick={() => onClickSelectorHandle("spyMap")}>
                    <div css={s.modeSelectIconContainer}>
                        <i class="fg-screen-mag-alt"/>
                    </div>
                    <span class="mode-selector-text" css={s.modeSelectText}>Spy Map</span>
                </button>
            </div>
        </div>
    );
};

export default ModeSelectMenuButton;